import { PrebuildModule } from '@dev/ee-api/ee-api-models';

import {
    ActionTypes,
    PrebuildModulesLoadAction,
    PrebuildModulesLoadSuccessAction,
    PrebuildModulesState,
    PrebuildModulesAddStartAction,
    PrebuildModulesAddSuccessAction,
    PrebuildModulesDeleteStartAction,
    PrebuildModulesDeleteSuccessAction,
    PrebuildModulesEditStartAction,
    PrebuildModulesEditSuccessAction
} from './types';
import { ApplicationState } from '..';

export const PrebuildModulesLoadStart = (): PrebuildModulesLoadAction => ({
    type: ActionTypes.LOAD_START,
});

export const PrebuildModulesLoadSuccess = (list: PrebuildModule[]): PrebuildModulesLoadSuccessAction => ({
    type: ActionTypes.LOAD_SUCCESS,
    payload: {
        list,
    },
});

export const PrebuildModulesLoadError = () => ({
    type: ActionTypes.LOAD_ERROR,
});

export const PrebuildModulesAddStart = (module: PrebuildModule): PrebuildModulesAddStartAction => ({
    type: ActionTypes.ADD_START,
    payload: {
        module,
    },
});

export const PrebuildModulesAddSuccess = (list: PrebuildModule[]): PrebuildModulesAddSuccessAction => ({
    type: ActionTypes.ADD_SUCCESS,
    payload: {
        list,
    },
});

export const PrebuildModulesEditStart = (id: string, newName: string): PrebuildModulesEditStartAction => ({
    type: ActionTypes.EDIT_START,
    payload: {
        id,
        newName
    },
});

export const PrebuildModulesEditSuccess = (list: PrebuildModule[]): PrebuildModulesEditSuccessAction => ({
    type: ActionTypes.EDIT_SUCCESS,
    payload: {
        list,
    },
});

export const PrebuildModulesDeleteStart = (id: string): PrebuildModulesDeleteStartAction => ({
    type: ActionTypes.DELETE_START,
    payload: {
        id,
    },
});

export const PrebuildModulesDeleteSuccess = (list: PrebuildModule[]): PrebuildModulesDeleteSuccessAction => ({
    type: ActionTypes.DELETE_SUCCESS,
    payload: {
        list,
    },
});

export const getPrebuildModulesStore = (store: ApplicationState): PrebuildModulesState =>
    store.prebuildModules || ({} as PrebuildModulesState);
